import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Countdown from 'react-countdown';
import Loader from './Loader';
import AppHeader2 from './AppHeader2';

const Completionist = () => <p id="RESEND_OTP" style={{display: 'block'}} ><Link to="#" onClick={(e) => {this.handleResendOTP(e); }} >Resend OTP</Link></p>;

// Renderer callback with condition
const renderer = ({ hours, minutes, seconds, completed }) => {
  if (completed) {
    // Render a complete state
    return <Completionist />;
  } else {
    // Render a countdown
    return (
      <p>
        {minutes}:{seconds}
      </p>
    );
  }
};

class SmsVerification extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            Notifications: false, 
            Verify: localStorage.getItem('Verified'),
            Customer: localStorage.getItem('userData'),
            SMS_VERIFIED: 'N'
        };

    }

    handleSubmit = (e) => {
        e.preventDefault();

        let err = 0;
        if ($('#frmSmsVerify')[0].checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            err++;
        }
        $('#frmSmsVerify')[0].classList.add('was-validated');

        if(err==0)
        {
            $('#submitLoading').css('display','block');
            
            const method = "POST";
            const body = new FormData(this.form);
            //console.log(body);
            var that = this;
            fetch("https://m.donedelivery.in/api/smsverify_api.php", { method, body })
            .then(function (response) {
                //console.log(response);
                return response.json();
            })
            .then(function (result) {

                //console.log(result);
                let notify = '';
                if(result.err!='')
                {
                    if(result.err=='1') notify = 'Invalid Customer';
                    else if(result.err=='2') notify = 'OTP Field is Empty';
                    else if(result.err=='3') notify = 'OTP Expired, Please regenrate again';
                    else if(result.err=='4') notify = 'Invalid Access Detected';
                    else if(result.err=='5') notify = 'OTP Expired, Please regenrate again';
                }

                //console.log(result);
                let sms_verified = 'N';
                let customer = result.customer;
                if(customer!='' && customer!=undefined)
                {
                    localStorage.setItem('userData',customer);
                    localStorage.setItem('Verified','Y');
                    localStorage.removeItem('tempData');
                    localStorage.removeItem('tempREG');
                    localStorage.removeItem('tempEMAIL');

                    sms_verified = 'Y';
                }

                that.setState({ Notifications: notify, SMS_VERIFIED:sms_verified });
                $('#submitLoading').css('display','none');
                if(notify!='')
                    $('#ModalAlert').modal('show');
          });
        }
    }

    handleResendOTP = (e) => {
        e.preventDefault();
        $('#RESEND_OTP').css('display','none');

        var customer = localStorage.getItem('userData');
        var that = this;
        fetch('https://m.donedelivery.in/api/resendotp_api.php?mode=REG&customer='+customer,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*',
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            //console.log(result);
            
            let notify = '';
            if(result.err!='')
            {
                if(result.err=='1') notify = 'Invalid Customer';
                else if(result.err=='2') notify = 'Invalid Access Detected';
            }
            
            let otp_resent = result.otp_resent;
            if(otp_resent=='' || otp_resent==undefined)
            otp_resent = '';

            if(otp_resent=='Y')
            {
                notify = 'New OTP has been sent to your mobile no';
            }

            that.setState({ Notifications: notify});
            if(notify!='')
            $('#ModalAlert').modal('show');
        });
        
    };

    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
            //window.location.reload(true);
        }
    }

    render() { 

        if(this.state.Verify=='Y') {
            if(localStorage.getItem('cartData'))
                return (<Redirect to={'/cart'}/>)
            else
			    return (<Redirect to={'/home'}/>)
        }
        
        if(this.state.SMS_VERIFIED=='Y')
        {
            if(localStorage.getItem('cartData'))
                return (<Redirect to={'/cart'}/>)
            else
			    return (<Redirect to={'/home'}/>)
        }
        
        let AppHeaderClass = 'appHeader bg-dark text-light';
        let AppHeaderLeft = '';
        let AppHeaderLeftLink = '';
        let AppHeaderTitle = 'Verification';
        let AppHeaderRight = '';
        let AppHeaderRightLink = '';
        let AppHeaderSearch = '';

        let tempREG = '';
        let tempEMAIL = '';
        if(localStorage.getItem('tempREG') && localStorage.getItem('tempREG')!=='null' && localStorage.getItem('tempREG')!==null)
            tempREG = localStorage.getItem('tempREG');

        if(localStorage.getItem('tempEMAIL') && localStorage.getItem('tempEMAIL')!=='null' && localStorage.getItem('tempEMAIL')!==null)
            tempEMAIL = localStorage.getItem('tempEMAIL');

        return (
            <div>
                {/*<Loader />*/}
                <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch}/>
                <div id="appCapsule">
                    <div className="login-form mt-5 pt-3 pr-3 pl-3">
                        <div className="section">
                            {tempREG!=='' && <h4 className="size-19">Enter The 6 Digit OTP Received on your Registered Mobile No:  {localStorage.getItem('tempREG')}</h4>}
                            {tempEMAIL!=='' && <h4 className="size-19">Enter The 6 Digit OTP Received on your Registered Email Id:  {localStorage.getItem('tempEMAIL')}</h4>}
                        </div>
                        <div className="section mt-2 mb-5">
                            <form id="frmSmsVerify" ref={el => (this.form = el)} onSubmit={this.handleSubmit} className="needs-validation" noValidate>
                                <input type="hidden" value="SMS_VERIFY" className="form-control" name="mode" id="mode" required />
                                <input type="hidden" value={localStorage.getItem('tempData')} className="form-control" name="customer" id="customer" required />
                                <div className="form-group boxed">
                                    <div className="input-wrapper">
                                        <input type="text" className="placeholder-size square-inputbox form-control verify-input verify-input-1" name="txtotp" id="txtotp" placeholder="••••••"  maxLength="6" required autoComplete="off"/>
                                        <div className="invalid-feedback">Please enter otp.</div>
                                    </div>
                                </div>
                                <Countdown date={Date.now() + 59000} renderer={renderer} />
                                <div className="form-button-group pl-4 pr-4 bg-common">
                                    <button type="submit" className="lt-space1 text-upper btn btn-danger btn-block square btn-md">
                                        <span className="spinner-border spinner-border-sm mr-05" id="submitLoading" style={{display: 'none'}} role="status" aria-hidden="true"></span>
                                        Verify</button>
                                </div>
                            </form>
                        </div>
                        <div className="modal fade dialogbox" id="ModalAlert" data-backdrop="static" tabIndex="-1" role="dialog">
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-icon text-danger">
                                        <ion-icon name="close-circle"></ion-icon>
                                    </div>
                                    <div className="modal-body"> 
                                        {this.state.Notifications} 
                                    </div>
                                    <div className="modal-footer">
                                        <div className="btn-inline"> 
                                            <button type="button" className="btn" data-dismiss="modal">Ok</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
      
export default SmsVerification;


// WEBPACK FOOTER //
// ./src/components/SmsVerification.js